import { render, staticRenderFns } from "./QuestionnaireItems.vue?vue&type=template&id=562a2712&scoped=true&"
import script from "./QuestionnaireItems.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireItems.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireItems.vue?vue&type=style&index=0&id=562a2712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a2712",
  null
  
)

export default component.exports